<template>
    <div>
        <loading
            :active.sync="loadingApp"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader shadow-header-footer">
            <div class="left">
                <router-link to="/" class="headerButton">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">Transaksi</div>
            <div class="right">
                <a class="headerButton" @click="refresh()">
                    <ion-icon name="sync-sharp"></ion-icon>
                </a>
            </div>
        </div>
        <!-- * App Header -->

        <!-- Extra Header -->
        <div class="extraHeader pr-0 pl-0">
            <ul class="nav nav-tabs lined" role="tablist">
                <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: ComponentProduct == true }"
                        @click="showComponentProduct"
                    >
                        Produk
                    </a>
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: ComponentDeposit == true }"
                        @click="showComponentDeposit"
                    >
                        Deposit
                    </a>
                </li>
            </ul>
        </div>
        <!-- * Extra Header -->

        <div id="appCapsule" class="extra-header-active">
            <!-- Transactions -->
            <div class="section full tab-content mb-2 mt-1">
                <!-- Produk tab -->
                <div
                    class="tab-pane"
                    :class="{ 'show active': ComponentProduct == true }"
                >
                    <ComponentProduct
                        :data="product"
                        :loadingButton="loadingButton"
                        :loadingApp="loadingApp"
                        @paginate="paginateProduct(product.next_page_url)"
                    >
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <input
                                    type="number"
                                    class="form-control"
                                    placeholder="Cari Transasksi"
                                    v-model="product.keywords"
                                    @input="eventSearchProduct('search')"
                                />
                                <i
                                    class="clear-input"
                                    @click="eventSearchProduct('clear')"
                                >
                                    <ion-icon name="close-circle"></ion-icon>
                                </i>
                            </div>
                        </div>
                    </ComponentProduct>
                </div>
                <!-- * Produk tab -->

                <!-- Deposit tab -->
                <div
                    class="tab-pane"
                    :class="{ 'show active': ComponentDeposit == true }"
                >
                    <ComponentDeposit
                        :data="deposit"
                        :loadingButton="loadingButton"
                        :loadingApp="loadingApp"
                        @paginate="paginateDeposit(deposit.next_page_url)"
                    >
                        <!-- <div class="form-group basic">
                            <div class="input-group">
                                <span class="input-group-text"><ion-icon name="search-outline"></ion-icon></span>
                                <input type="number" class="form-control" placeholder="Cari Nominal" v-model="deposit.keywords" @input="searchDeposit">
                                
                            </div>
                        </div> -->
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <input
                                    type="number"
                                    class="form-control"
                                    placeholder="Cari transaksi"
                                    v-model="deposit.keywords"
                                    @input="eventSearchDeposit('search')"
                                />
                                <i
                                    class="clear-input"
                                    @click="eventSearchDeposit('clear')"
                                >
                                    <ion-icon name="close-circle"></ion-icon>
                                </i>
                            </div>
                        </div>
                    </ComponentDeposit>
                </div>
                <!-- * Deposit tab -->
            </div>
            <!-- * Transactions -->
        </div>
    </div>
</template>
<script>
    import moment from 'moment';
    moment.locale('id');
    import $axios from './../../api.js';
    import ComponentProduct from './product/Index';
    import ComponentDeposit from './deposit/Index';
    import { mapState } from 'vuex';
    export default {
        name: 'Referral',
        components: {
            ComponentProduct,
            ComponentDeposit,
        },
        data() {
            return {
                ComponentProduct: false,
                ComponentDeposit: false,
                product: {
                    data: [],
                    keywords: '',
                },
                deposit: {
                    data: [],
                    keywords: '',
                },
                loadingApp: true,
                loadingButton: false,
            };
        },
        created() {
            this.ComponentProduct = true;
            this.paginateProduct();
        },
        computed: {
            ...mapState(['toast']),
        },
        methods: {
            showComponentProduct() {
                if (this.ComponentProduct == false) {
                    this.ComponentProduct = true;
                    this.ComponentDeposit = false;
                    this.loadingApp = true;
                    this.product = {
                        data: [],
                        keywords: '',
                    };
                    this.RESET_LOADING();
                    this.paginateProduct();
                }
            },
            showComponentDeposit() {
                if (this.ComponentDeposit == false) {
                    this.ComponentDeposit = true;
                    this.ComponentProduct = false;
                    this.deposit = {
                        data: [],
                        keywords: '',
                    };
                    this.RESET_LOADING();
                    this.paginateDeposit();
                }
            },

            paginateProduct(url = '') {
                this.loadingButton = true;
                $axios
                    .get(url ? url : '/transaction/product', {
                        params: {
                            keywords: this.product.keywords,
                        },
                    })
                    .then(response => {
                        if (!this.product.data) {
                            this.product = response.data.data;
                        } else {
                            this.product.data.push(...response.data.data.data);
                            this.product.to = response.data.data.to;
                            this.product.per_page = response.data.data.per_page;
                            this.product.next_page_url =
                                response.data.data.next_page_url;
                        }
                        this.loadingButton = false;
                        this.loadingApp = false;
                    })
                    .catch(() => {
                        this.loadingButton = false;
                        this.loadingApp = false;
                    });
            },
            paginateDeposit(url = '') {
                this.loadingButton = true;
                $axios
                    .get(url ? url : '/transaction/deposit', {
                        params: {
                            keywords: this.deposit.keywords,
                        },
                    })
                    .then(response => {
                        if (!this.deposit.data) {
                            this.deposit = response.data.data;
                        } else {
                            this.deposit.data.push(...response.data.data.data);
                            this.deposit.next_page_url =
                                response.data.data.next_page_url;
                        }
                        this.loadingButton = false;
                        this.loadingApp = false;
                    })
                    .catch(() => {
                        this.loadingButton = false;
                        this.loadingApp = false;
                    });
            },

            // Function Search Product Data
            searchProduct(keywords, second) {
                if (this.time) {
                    clearTimeout(this.time);
                }
                this.time = setTimeout(() => {
                    this.loadingApp = true;
                    this.product = {
                        data: [],
                        keywords: keywords,
                    };
                    this.paginateProduct();
                }, second);
            },
            eventSearchProduct(value) {
                if (value == 'search') {
                    this.searchProduct(this.product.keywords, 500);
                } else if (value == 'clear') {
                    this.searchProduct('', 300);
                }
            },

            searchDeposit(keywords, second) {
                if (this.time) {
                    clearTimeout(this.time);
                }
                this.time = setTimeout(() => {
                    this.loadingApp = true;
                    this.deposit = {
                        data: [],
                        keywords: keywords,
                    };
                    this.paginateDeposit();
                }, second);
            },
            eventSearchDeposit(value) {
                if (value == 'search') {
                    this.searchDeposit(this.deposit.keywords, 500);
                } else if (value == 'clear') {
                    this.searchDeposit('', 300);
                }
            },

            refresh() {
                this.loadingApp = true;
                if (this.ComponentProduct == true) {
                    this.product = {
                        data: [],
                        keywords: this.product.keywords,
                    };
                    this.paginateProduct();
                } else {
                    this.deposit = {
                        data: [],
                    };
                    this.paginateDeposit();
                }
            },
            RESET_LOADING() {
                this.loadingApp = true;
                this.loadingButton = false;
            },
        },
    };
</script>
